<template>
  <div class="select-place select-start-place" ref="selectStartPlace">
    <el-input class="search-text"
              ref="selectStartInput"
              :placeholder="isHasSelectValue ?(isFocus ? (selectValue.portCode ? selectValue.portNamec || '' : (selectValue.cityNamec ? selectValue.cityNamec : '')) : ''):placeholder"
              v-popover:startPopover
              v-model="searchText"
              :disabled="inputDisabled"
              @input="inputing = true"
              @click.stop="noEvent"
              @blur="handlerBlur"
              @focus="handlerFocus"
              @keyup.enter.native="handlerEnter"
    ></el-input>
    <div class="value-text"
         :class="[startTextStatus]"
    >
      <slot :data="selectValue">
        <!-- <div class="text-row">{{selectValue.namee}}</div> -->
        <!-- <div class="text-row">{{selectValue.portCode ? selectValue.portNamec || '' : (selectValue.cityNamec ? selectValue.cityNamec : '')}}</div> -->
        <div class="text-row">
          {{selectValue.portNamec ? `${selectValue.portNamec}` : ''}}{{selectValue.portNamec && selectValue.cityNamec ? ', ' : ''}}{{selectValue.cityNamec || ''}}{{(selectValue.portNamec || selectValue.cityNamec) && selectValue.countryNamec ? ', ' : ''}}{{selectValue.countryNamec || ''}}
        </div>
      </slot>
    </div>
    <el-popover
      popper-class="popover-select-place popover-select-start-place"
      ref="startPopover"
      trigger="manual"
      placement="bottom-start"
      title=""
      :width="popoverWidth"
      v-model="visibleListPopover"
    >
      <div class="place-list" v-loading="loading">
        <template v-if="loading">
          <div class="no-data">加载中</div>
        </template>
        <template v-else-if="!list.length">
          <template v-if="searchText">
            <div class="no-data">{{noDataMessage}}</div>
          </template>
          <template v-else>
            <div class="no-data">{{noDataMessage}}</div>
          </template>
        </template>
        <template v-else>
          <div class="place-item"
              :class="{isCurrent: selectValue && item.id === selectValue.id}"
               @click="clickItem(item,index)"
               v-for="(item,index) in list"
               :key="item.id">
            <div class="place-item__type">
              <img class="place-item__type-icon" :src="ossPath + (item.portCode ? '/pages/home/icon_port_new.png' : '/pages/home/icon_city_type.png')">
              <div class="place-item__type-text">{{item.portCode ? '港口' : '城市'}}</div>
            </div>
            <div class="place-item__content">
              <div class="place-item__text-row">{{item.portNamee ? `${item.portNamee}, ` : ''}}{{item.cityNamee ? `${item.cityNamee}, ` : ''}}{{item.countryNamee || ''}}{{item.portCode ? `(${item.portCode})` : ''}}</div>
              <div class="place-item__text-row">{{item.portNamec ? `${item.portNamec}, ` : ''}}{{item.cityNamec ? `${item.cityNamec}, ` : ''}}{{item.countryNamec || ''}}</div>
            </div>
          </div>
        </template>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {isObject,isArray,debounce} from "my-tools-kit";
import fa from "element-ui/src/locale/lang/fa";

export default {
  name: "selectStartPlace",
  props:{
    value:{ //选中值
      type:Object,
      default(){
        return {
          id:"",
          namec:"",
          namee:"",
        }
      },
    },
    inquiryBusinessType: { // 询盘业务类型  1 海运整柜 、2 FBA、3 海运拼箱、4 空运、5 陆运
      type: [String,Number],
      default: 1,
    },
    inquiryType: { // 1、港到港 2、整柜到门 3、门到港 4、门到门
      type: [String,Number],
      default: 2,
    },
    // defaultValue:{ //默认选中起运地id
    //   type:[String,Number],
    //   default:"",
    // },
    popoverWidth:{ //弹出层宽度
      type:String,
      default:"476",
    },
    placeholder:{ //输入框提示信息
      type:String,
      default:"请输入城市/港口",
    },
    noDataMessage:{ //列表为空时的提示信息
      type:String,
      default:"暂未找到您要的信息",
    },
    isEmptyCanSearch:{ // 输入框文本为空时是否获取列表
      type:Boolean,
      default:true,
    },
    isEndPlace:{ // 是否将请求地址改为目的地
      type:Boolean,
      default:false,
    },
    // bubbleDefaultChange:{ // 是否冒泡“默认值变化导致的选中变更change”
    //   type:Boolean,
    //   default:false,
    // },
    // clearable:{ // 是否显示清除按钮
    //   type:Boolean,
    //   default:false,
    // },
    cityId:{ //请求起运港时可选参数 城市ID
      type:[String,Number],
      default:"",
    },
    countryId:{ //请求目的港港时可选参数 国家ID
      type:[String,Number],
      default:"",
    },
    needBeforeParams:{
      type:Boolean,
      default:false,
    },
    disabled:{
      type:Boolean,
      default:false,
    },
    loadingDisabled:{ //加载中是否禁用
      type:Boolean,
      default:false,
    },
  },
  data(){
    return {
      loading:false,
      searchText:"",//输入框搜索文本
      isFocus:false,//当前输入框是否获得焦点
      selectValue:{}, //选中的值
      listAll:[],
      list:[],
      visibleListPopover:false,// 显示列表弹出层
      inputing: false
    }
  },
  computed:{
    /**
     * 回显文本状态 class
     * @returns {string}
     */
    startTextStatus(){
      if(this.searchText.length) return "opacity-0"
      if(this.inputing) return "opacity-0"
      if(this.isFocus) return "opacity-0"
      if(this.isFocus) return "opacity-04"
      return "";
    },
    // /**
    //  * 最终显示在列表的数据
    //  * @returns {[]}
    //  */
    // filterList(){
    //   let list = this.list;
    //   return list;
    // },
    /**
     * 是否有选中值
     * @returns {*}
     */
    isHasSelectValue(){
      // 有选中值时 输入框不显示placeholder
      return this.selectValue.id
    },
    inputDisabled(){
      if(this.disabled) return true;
      if(this.loadingDisabled && this.loading) return true;
      return false;
    },
  },
  watch:{
    value:{
      immediate:true,
      handler(newValue,oldValue){
        console.log("【selectStartPlace】监听到value变化",newValue,newValue === this.selectValue?"不处理":"处理");
        if(newValue === this.selectValue) return false;
        this.selectValue = newValue;
      }
    },
    /* 监听搜索输入框 */
    searchText(newValue){
      this.list = [];
      this.loading = true;
      this.changeSearch();
    },
  },
  methods:{
    /**
     * 获取起运地列表
     */
    getList(){
      // const urlList = {
      //   start:"/api/fullContainer/getCityPortList/1",
      //   end:"/api/fullContainer/getCityPortList/2",
      // };
      // let url;
      // if(this.isEndPlace){
      //   url = urlList.end;
      // }else{
      //   url = urlList.start;
      // }
      const data = {
        type: this.isEndPlace ? 2 : 1,
        inquiryBusinessType: this.inquiryBusinessType
      }
      if (data.inquiryBusinessType == '1') data.inquiryType = this.inquiryType
      // if (this.countryId) data.countryId = this.countryId
      return this.axios.post('/api/fullContainer/getHomeCityPortList', data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return {data:res.datas||[]};
        })
    },
    getDefaultList(){
      this.loading = true;
      this.getList()
        .then(res=>{
          setTimeout(()=>this.loading = false,500);
          this.listAll = res.data;
          this.list = res.data;
        })
        .catch(res=>{
          setTimeout(()=>this.loading = false,500);
          this.listAll = [];
          this.list = [];
        })
    },
    /**
     * 空函数
     * */
    noEvent(){},
    handleSearchFilter(text) {
      if (!text) this.list = this.listAll
      let baseList = this.listAll
      let filterList = [];
      filterList = this.searchList(text,baseList);
      this.list = filterList;
      this.loading = false;
    },
    /**
     * 搜索函数
     * @param text  {string}  搜索文本
     * @param baseList  {array} tabItem对应的list数据
     * @returns {*[]}
     */
    searchList(text="",baseList=[]){
      let filterList = [];
      let filterFunction = (text="",item)=>{
        // console.log("============",item[this.itemLabelKey])
        let itemLabel = String(item.cityNamec||"");
        let itemLabelE = String(item.cityNamee||"")
        let itemLabel1 = String(item.portNamec||"");
        let itemLabelE1 = String(item.portNamee||"")
        let itemLabel2 = String(item.countryNamec||"");
        let itemLabelE2 = String(item.countryNamee||"")
        let itemLanbelCode = String(item.portCode || '')
        let reg = RegExp(text,"ig");
        return reg.test(itemLabel) || reg.test(itemLabelE) || reg.test(itemLabel1) || reg.test(itemLabelE1) || reg.test(itemLabel2) || reg.test(itemLabelE2) || reg.test(itemLanbelCode);
      };
      filterList = baseList.filter(item=>{
        return filterFunction(text,item);
      });
      return filterList;
    },
    /**
     * 触发搜索
     */
    changeSearch:debounce(function(){
      let text = this.searchText.replace(/(^\s+)|(\s+$)/g,"");
      if(!text && !this.isEmptyCanSearch){
        // 输入框为空时 且 不允许为空搜索时
        return this.loading = false;
      }
      this.handleSearchFilter(text)
    },200,false),
    /**
     * 点击/选中某条数据
     */
    clickItem(item,index){
      const data = this.selectItem(item);
      this.$refs.selectStartInput.blur();
      this.hideListPopover();
    },
    selectItem(item,isChange = true){
      if (this.selectValue.id === item.id) isChange = false
      let data = Object.assign({},item);
      this.selectValue = data;
      if(isChange) {
        this.$emit("input",data);
        this.$emit("change",data);
      }
      return data;
    },
    /**
     * 失去焦点时触发
     */
    handlerBlur(){
      this.inputing = false
      this.isFocus = false;
      this.$emit('blur')
    },
    /**
     * 获得焦点时触发
     */
    handlerFocus(){
      this.isFocus = true;
      this.showListPopover();
      this.$emit('focus')
    },
    /**
     * 按下回车时触发
     */
    handlerEnter(){
      console.log('按下回车')
      if(this.list.length){
        this.clickItem(this.list[0]);
      }
    },
    /**
     * 显示、隐藏列表
     */
    showListPopover(){
      this.visibleListPopover = true;
      this.loading = false
      if(this.isEmptyCanSearch) {
        if(this.listAll.length) return this.list = this.listAll;
        else this.getDefaultList()
      }
    },
    hideListPopover(e){
      this.visibleListPopover = false;
      this.list = [];
      this.searchText = "";
    },
    /**
     * 全局关闭
     */
    globalClosePopover(e){
      let screenDoc = this.$refs.selectStartPlace;
      if (screenDoc && !screenDoc.contains(e.target)) this.hideListPopover();
    },
  },
  created() {
    document.addEventListener("click",this.globalClosePopover,false);
    this.getDefaultList()
  },
  destroy() {
    document.removeEventListener("click",this.globalClosePopover);
  },
}
</script>

<style scoped lang="less">
/* input和显示文本容器 */
.select-place{
  width: 100%;
  background-color: #F5F5F5;
  position: relative;
  z-index: 1;
}

/* 搜索框 */
.search-text{
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  font-size: 16px;
  &,
  /deep/ input{
    padding: 0;
    background-color: transparent !important;
  }
  /deep/ input{
    width: 100%;
    height: 100%;
    border: none;
  }
}

/* 选中值回显文本 */
.value-text{
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  // transition: opacity 0.4s ease;
}
.opacity-0{
  opacity: 0;
}
.opacity-04{
  opacity: 0.4;
}
.text-row{
  padding: 0 11px;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 列表 */
.place-list{
  min-height: 50px;
}
.place-item{
  width: 100%;
  min-height: 50px;
  margin: 7px 0;
  //padding: 20px 20px 18px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover{
    background-color: rgba(255, 77, 1, .1);
    color: #FF4D01;
  }
  &.isCurrent {
    background-color: rgba(255, 77, 1, .1);
    color: #FF4D01;
    .place-item__text-row {
      color: #FF4D01;
    }
  }
  &__type{
    width: 64px;
    position: relative;
    z-index: 1;
    // &:before{
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   bottom: 0;
    //   right: 0;
    //   width: 1px;
    //   background-color: #D7D7D7;
    // }
    &-icon{
      //width: 19px;
      display: block;
      min-width: 1px;
      width: auto;
      height: 20px;
      margin: 0 auto;
    }
    &-text{
      text-align: center;
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }
  &__content{
    margin-left: 5px;
  }
  &__text-row{
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    &:nth-of-type(2) {
      font-size: 12px;
    }
  }
  &:hover &__text-row{
    color: inherit;
  }
}
.no-data{
  font-size: 16px;
  color: #666666;
  line-height: 30px;
  padding: 20px;
}
</style>

<style lang="less">
/* 列表弹出层 */
.popover-select-place{
  box-sizing: border-box;
  margin-left: -27px;
  max-height: 247px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.1);
  border-radius: 8px;
  overflow-y: auto;
  border: none;
  &,
  &.el-popover--plain{
    padding: 0 ;
  }
  &[x-placement^="bottom"] {
    margin-top: 28px;
  }
  &[x-placement^="top"] {
    margin-bottom: 10px;
  }
  &[x-placement^="bottom"] .popper__arrow {
    left: 50px!important;
    &::after {
      top: -9px;
      border-width: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/inquiryQueryBar/selectPlace.vue